import { isFlagEnabled } from "./isFlagEnable";
import { isInterestSensitiveWholeLifePolicy } from "./isInterestSensitiveWholeLifePolicy";
import { isPolicyInactiveByPolicyStatus } from "./isPolicyInactiveByPolicyStatus";
import { isG4LPolicy } from "./isG4LPolicy";

export const isAllowedToMakeCCPayment = (policy, paymentType) => {
  const productType = policy?.product?.type?.toUpperCase();

  // Disable payment for Good For Life (G4L) plans
  if (isG4LPolicy(policy)) return false;

  // Exclude annuities
  if (productType?.startsWith("A")) return false;
  // Exclude LZ / LQ / LOP policies
  if (["LZ", "LQ", "LOP"].includes(productType)) return false;
  if (isInterestSensitiveWholeLifePolicy(policy)) return false;
  if (isPolicyInactiveByPolicyStatus(policy?.status)) return false;
  if (paymentType === "onetimepayment") return true;

  if (isFlagEnabled("ENABLE_ALLOWED_CC_PAYMENT_BY_POLICY_TYPES")) {
    let paymentTypes = policy?.allowedPaymentTypes;

    if (paymentTypes?.length > 0) {
      let creditCardPaymentType = paymentTypes.find(
        (p) => p?.paymentType?.toLowerCase() === "credit card"
      );
      if (creditCardPaymentType) return true;
    }
    return false;
  } else {
    return true;
  }
};
